import '@stimulus/polyfills'
import '../src/utils/localStorage_protection'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

function importAll (r) {
  r.keys().forEach(r)
}
importAll(require.context('../../components/site', true, /desktop\/component\.js$/))
importAll(require.context('../../components/my/desktop', true, /component\.js$/))
importAll(require.context('../src/common', true, /.*\.js$/))

const application = Application.start()
application.load(definitionsFromContext(require.context('../../components/site', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/my/desktop', true, /component_controller\.js$/)))

const images = require.context('../images', true)
export { images }
